import { faker } from "@faker-js/faker";
import { creators } from "../creators";
import { moderators } from "../moderators";

export const createBatch = ({
    batchId,
    creator = creators[0],
    moderatorId = moderators[0].id,
    photoShoot
}) => {
    const id = batchId || faker.string.numeric(6);

    return {
        id,
        creator,
        moderator: {
            id: moderatorId
        },
        photoShoot,
        // Consumer can override manually the following default props
        createdAt: faker.date.anytime().toString(), // '2022-07-31T01:33:29.567Z'
        moderationStatus: "BATCH_MOD_ASSIGNED",
        releaseCount: 2,
        __typename: "ModerationPhotoBatchListType",
        submittedAt: "2024-05-21T16:59:24.838838+00:00",
        containsReleaseOrEditorialFlags: false,
        containsExplicitOrTextFlags: false,
        containsSavedForLater: false,
        currentView: "active",
        visModActiveIds: [],
        visModSavedIds: [],
        photoCounts: {
            id: id,
            photoUploadCount: 0,
            visuallyPublishedCount: 4,
            fullyPublishedCount: 7,
            inVisualModerationCount: 8,
            deniedCount: 3
        },
        isEditable: {
            moderator: true,
            releases: true,
            photoShoot: true,
            flags: true,
            uploadToggleBand: true,
            uploadFlags: true,
            uploadTitle: true,
            uploadDesc: true,
            publishing: true
        },
        creatorTier: {
            internalDisplayName: "Tier 3",
            __typename: "PhotoCreatorTierType"
        }
    };
};
